import { API } from '@shared/types/api';
import { createCtx } from '@shared/util/context';
import { State as StateContext, initialState } from './reducer';

interface ActionsContext {
  addCard(card: API.CardFragment): void;
  removeCard(card: API.CardFragment): void;
  removeCardById(id: string): void;
  loadingCards: string[];
  setLoadingCard: (id: string, isLoading: boolean) => void;
  setActive(value: boolean): void;
  reset(): void;
}

export const [useCardSelectionState, CardSelectionStateProvider] =
  createCtx<StateContext>(initialState);

export const [useCardSelectionActions, CardSelectionActionsProvider] = createCtx<ActionsContext>({
  addCard: () => {},
  removeCard: () => {},
  removeCardById: () => {},
  loadingCards: [],
  setLoadingCard: () => {},
  setActive: () => {},
  reset: () => {},
});
